document.addEventListener('DOMContentLoaded', function () {
(function () {
  const INPUT_SEL = '.search__input';
  const LINK_SEL  = '.see_all_res';

  function debounce(fn, wait = 150) {
    let t = null;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  }

  function updateLink() {
    const input = document.querySelector(INPUT_SEL);
    const q = (input && input.value) ? input.value.trim() : '';
    const link = document.querySelector(LINK_SEL);
    if (!link) return false;

    const newHref = `/search?q=${encodeURIComponent(q)}`;
    if (link.href !== newHref) {
      link.href = newHref;
      console.log('Updated .see_all_res ->', newHref);
    }
    return true;
  }

  const debouncedUpdate = debounce(updateLink, 120);

  // Update while typing
  document.addEventListener('input', (e) => {
    if (e.target && e.target.matches(INPUT_SEL)) {
      debouncedUpdate();
    }
  });

  // MutationObserver: only act when the link itself is inserted/replaced
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(LINK_SEL)) {
          updateLink();
        } else if (node.querySelector && node.querySelector(LINK_SEL)) {
          updateLink();
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: false // 🚫 don't observe attribute changes
  });

  // Initial run
  updateLink();
})();
})